<template>
  <div>
    <div class="flex justify-between flex-wrap">
      <h3 class="title">Lijst van contactlijnen</h3>
      
      <div class="flex">
        <router-link class="button is-primary mr-4" :to="{ name: 'newLine' }">
          <span class="icon">
            <i class="mdi mdi-24px mdi-plus" />
          </span>

          <span>Nieuwe contactlijn toevoegen</span>
        </router-link>

        <SearchField @change="filter = $event" />
      </div>
    </div>

    <TableContainer
      :config="tableConfig"
      :data="tableData"
      :filter="filter"
      :filterBy="['channel.name', 'entity.name']"
      :onRowClick="handleOnRowClick" />
  </div>
</template>

<script>
import { compose, path, prop } from 'ramda';
import { dateTime } from '@/filters';

import { YesOrNo } from '@/components/shared';

const tableConfig = [
  {
    key: 'id',
    label: 'ID',
    cellDataGetter: prop('id'),
  },
  {
    key: 'entity',
    label: 'Entiteit',
    cellDataGetter: path(['entity', 'name']),
  },
  {
    key: 'channel',
    label: 'Kanaal',
    cellDataGetter: path(['channel', 'name']),
  },
  {
    key: 'lastUpdated',
    label: 'Geupdate',
    cellDataGetter: compose(
      dateTime,
      prop('updated'),
    ),
    sortDataGetter: prop('updated'),
  },
  {
    key: 'isActive',
    label: 'Is actief?',
    cellDataGetter: prop('active'),
    cellRenderer: YesOrNo,
  },
  {
    key: 'isOpen',
    label: 'Is open?',
    cellDataGetter: prop('isOpen'),
    cellRenderer: YesOrNo,
  },
];

export default {
  name: 'ContactLines',

  props: ['data'],

  data() {
    return {
      filter: '',
      tableConfig,
      tableData: this.data.contactLines,
    };
  },

  methods: {
    handleOnRowClick({ id }) {
      this.$router.push({ name: 'editLine', params: { id } });
    },
  },
};
</script>
